jQuery($ => {
    class WoocommerceProductInfo {
      constructor(element) {
        this._          = element;
        this._element   = $(element);
        this._quantities = this._element.find('.quantity');

        this.init();
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      init() {
        this.setupHandlers();
        this.setupVariationHandlers();
        this._element.trigger( 'init', this );
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      setupHandlers() {
        this._quantities.each((_, quantity) => {
          this.setupQuantity($(quantity));
        });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Variation Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      setupVariationHandlers() {
        const $form = this._element.find('form.variations_form');
        if ( ! $form.length ) return;

        const $sku = this._element.find('.sku');
        const $skuWrapper = $sku.closest('.sku_wrapper');
        const originalSku = $sku.length ? $sku.text() : '';

        const isNa = (value) => value && value.toUpperCase() === 'N/A';
        const setSkuVisibility = (skuValue) => {
          if ( isNa( skuValue ) ) {
            $skuWrapper.hide();
          } else {
            $skuWrapper.show();
            $sku.text( skuValue );
          }
        };

        // Initialise based on original SKU
        if ( isNa( originalSku ) ) {
          $skuWrapper.hide();
        }

        $form.on('found_variation', (e, variation) => {
          setSkuVisibility( variation.sku );
        });

        $form.on('reset_data', () => {
          setSkuVisibility( originalSku );
        });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Quantity
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      setupQuantity($quantity) {
        const $input = $quantity.find('.input-text.qty');
        if (!$input.length) return;

        const $minus = $('<button type="button" class="o-woocommerce-product-info__qty-btn o-woocommerce-product-info__qty-btn--minus" aria-label="Decrease quantity"></button>');
        const $plus  = $('<button type="button" class="o-woocommerce-product-info__qty-btn o-woocommerce-product-info__qty-btn--plus" aria-label="Increase quantity"></button>');

        $quantity.prepend($minus);
        $quantity.append($plus);

        $minus.on('click', () => this.handleQuantityChange($input, -1));
        $plus.on('click', () => this.handleQuantityChange($input, 1));
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Quantity Change
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleQuantityChange($input, delta) {
        const min  = parseFloat($input.attr('min')) || 0;
        const max  = parseFloat($input.attr('max')) || Infinity;
        const step = parseFloat($input.attr('step')) || 1;
        const val  = parseFloat($input.val()) || min;

        const newVal = Math.min(max, Math.max(min, val + (step * delta)));

        $input.val(newVal).trigger('change');
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $.fn.woocommerce_product_info = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].woocommerce_product_info = new WoocommerceProductInfo(_[i], opt);
        else
          ret = _[i].woocommerce_product_info[opt].apply(_[i].woocommerce_product_info, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.o-woocommerce-product-info').woocommerce_product_info();
});